export const JUNIOR_SPEECH_API_URL = 'https://speech.wrts.nl';

export const JUNIOR_ENVIRONMENTS = {
	nl_develop: {
		api_url: 'https://junior-api.squla.dev',
		oauth_auth_url: 'https://leukleren.squla.dev/oauth2/auth',
		oauth_client_id: 'edx@junior',
		oauth_response_type: 'token',
	},
	nl_staging: {
		api_url: 'https://junior-api-staging.squ.la',
		oauth_auth_url: 'https://funlearning-nl-staging.squ.la/oauth2/auth',
		oauth_client_id: 'edx@junior',
		oauth_response_type: 'token',
	},
	nl_master: {
		api_url: 'https://junior-api.squla.nl',
		oauth_auth_url: 'https://leukleren.squla.nl/oauth2/auth',
		oauth_client_id: 'edx@junior',
		oauth_response_type: 'token',
	},
} as const;

export type JuniorEnvironment = keyof typeof JUNIOR_ENVIRONMENTS;

export const isJuniorEnvironment = (value: unknown): value is JuniorEnvironment =>
	typeof value === 'string' && Object.prototype.hasOwnProperty.call(JUNIOR_ENVIRONMENTS, value);
